import { useRef } from 'react';
import { CombinedTokenStorage } from '../storage';
import { TokenClient } from '../TokenClient';
/**
 * Creates and returns TokenClient for given route
 */
export const useTokenClient = url => {
  const tokenClientRef = useRef();
  if (!tokenClientRef.current) {
    tokenClientRef.current = new TokenClient({
      url,
      requestOptions: {
        method: 'GET'
      },
      storage: new CombinedTokenStorage()
    });
  }
  return tokenClientRef.current;
};
//# sourceMappingURL=useTokenClient.js.map